const dropReasons = Object.freeze({
  TrasladoInterno: 3,
  EstudianteTrasladaOtraCorporaciónSolicitudPadre: 24,
  CambioProgramaEscolarLimitanOfrecimiento: 34,
  OfrecimientoPresencialPadresDeseanServicioCiberterapia: 35,
});

export default dropReasons;
